import { html } from '../../mixins/katapult-element';
import { KatapultEditorTemplate } from './katapult-editor-template';
import { CamelCase } from '../../modules/CamelCase.js';
import '../katapult-elements/katapult-button.js';
import { GeneratePushID } from '../../modules/GeneratePushID';
class KatapultAttributeSetsEditor extends KatapultEditorTemplate {
  static get template() {
    return html`
      ${super.style}
      <style>   
        .body {
          margin-left: 48px;
        }

        [drag-handle]:hover {
          cursor: move;
        }

      </style>
      <katapult-firebase-worker path="[[modelSpaceDetails.path]]/models/attributes" data="{{otherAttributes}}"></katapult-firebase-worker>
      <paper-table style="overflow: hidden;" rounded outline white>
        <paper-row short grey divider>
          <paper-cell>Attribute</paper-cell>
        </paper-row>
        <paper-table-scroll on-sort-changed="sortChanged">
          <template is="dom-repeat" items="[[attributes]]" as="item">
            <paper-row divider slot="sortable">
              <paper-cell drag-handle icon>
                <iron-icon icon="katapult-misc:drag-indicator"></iron-icon>
              </paper-cell>
              <paper-cell>
                <katapult-drop-down label="Select an Attribute" items="[[otherAttributes]]" label-function="[[camelCaseKey]]" value-path="$key" value="[[item.attribute]]" no-label-float data-path="_itemData.attributes.$(model.item.$key).attribute" on-selected-changed="updateProperty">
                </katapult-drop-down>
              </paper-cell>
              <katapult-button iconOnly noBackground noBorder icon="delete" on-click="removeAttribute"></katapult-button>
            </paper-cell>
            </paper-row>
          </template>
          </paper-table-scroll>
        <paper-row short>
          <paper-cell center pointer style="color: var(--paper-grey-600);" ripple on-click="addAttribute">
            <span>ADD ATTRIBUTE</span>
            <iron-icon style="margin-left: 8px;" icon="add-circle-outline"></iron-icon>
          </paper-cell>
        </paper-row>
      </paper-table>
      ${super.createItemContainer}
`;
  }

  static get properties() {
    return {
      attributes: Array,
      defaultOperator: {
        type: String,
        value: 'all'
      },
      otherAttributes: Object
    };
  }

  static get observers() {
    return ['attributesChanged(_itemData.attributes.*)'];
  }

  ready() {
    super.ready();
  }

  addAttribute(e) {
    this.set(`_itemData.attributes.${GeneratePushID()}`, { order: this.attributes.length });
  }

  attributesChanged(changeRecord) {
    if (changeRecord.base == null) this.set('_itemData.attributes', {});
    else {
      this.attributes = Object.entries(changeRecord.base ?? {})
        .filter((x) => x)
        .map(([$key, value]) => ({ ...value, $key }))
        .sort((a, b) => a.order - b.order);
    }
  }

  camelCaseKey(x) {
    if (x) return CamelCase(x.$key);
    return '';
  }

  removeAttribute(e) {
    let removedItem = this._itemData.attributes[e.model.item.$key];
    delete this._itemData.attributes[e.model.item.$key];
    let prevIndex = e.model.__data.index;
    this.shiftOrder(removedItem, this.attributes.length - 1, prevIndex, -1);
    this.notifyPath('_itemData.attributes');
  }

  sortChanged(e) {
    let removedItem = this.attributes.splice(e.detail.prevIndex, 1)[0];
    this.set(`_itemData.attributes.${removedItem.$key}.order`, e.detail.index);
    this.shiftOrder(removedItem, e.detail.index, e.detail.prevIndex, e.detail.shift);
  }

  shiftOrder(removedItem, index, prevIndex, shift) {
    this.attributes.forEach((attribute) => {
      if (attribute.$key != removedItem.$key) {
        //if shift is positive, we are moving the item up, so we need to move all items between the prevIndex and the newIndex up one
        if (shift > 0 && attribute.order <= prevIndex && attribute.order >= index) {
          this.set(`_itemData.attributes.${attribute.$key}.order`, attribute.order + shift);
        }
        //if shift is negative, we are moving the item down, so we need to move all items between the prevIndex and the newIndex down one
        else if (shift < 0 && attribute.order >= prevIndex && attribute.order <= index) {
          this.set(`_itemData.attributes.${attribute.$key}.order`, attribute.order + shift);
        }
      }
    });
  }
}

customElements.define('katapult-attribute-sets-editor', KatapultAttributeSetsEditor);
